import axios from 'axios'

// 后端地址
const baseURL = 'https://school.tangsuankeji.com'
// const baseURL = 'http://localhost:3001'
// const baseURL = 'https://192.168.1.14:63414'
// const baseURL = ''
// 创建 axios 实例
const api = axios.create({
  baseURL,
  proxy: false,
  // proxy: {
  //   host: '192.168.1.14',
  //   port: 63414,
  //   protocol: 'http'
  // }
})

// 根据 userId 获取 user 信息
export const fetchUser = async (userId: string) => {
  const response = await api.get<UserResponse>('/qywxapi/utils/user', {
    params: {
      userid: userId,
    }
  });
  return response.data
}

// 根据 externalUserId 获取 externalUser 信息
export const fetchExternalUser = async (externalUserId: string, cursor?: string) => {
  const response = await api.get<ExternalUserResponse>('/qywxapi/utils/externalcontact', {
    params: {
      external_userid: externalUserId,
      cursor
    }
  })
  localStorage.setItem("userInFo", JSON.stringify(response.data.external_contact));
  return response.data.external_contact
}
//根据外部用户userId换取数据库用户id
export const getqywxguardian = async (externalUserId: any) => {
  const response = await api.post<ExternalUserResponse>(`/qywxapi/utils/getqywxguardian?externalUserId=${externalUserId}`)
  return response.data
}
//获取页面数据
export const userinfo = async (guardiansld: any,activityld: any) => {
  const response = await api.post<ExternalUserResponse>(`/qywxapi/utils/studentinfo?guardiansId=${guardiansld}&activityId=${activityld}`)
  return response.data
}

// 根据 externalChatId 获取 chat 信息
export const fetchExternalChat = async (externalChatId: string) => {
  const response = await api.get<ExternalChatResponse>('/qywxapi/utils/externalcontact/groupchat/get', {
    params: {
      chat_id: externalChatId,
      need_name : 1
    }
  })

  return response.data.group_chat
}

// 根据 code 换取 userId，作为用户身份验证
export const fetchUserId = async (code: string) => {
  const response = await api.get<AuthResponse>('/qywxapi/utils/user/getuserinfo', {
    params: {
      code
    }
  })
  const res = JSON.parse(JSON.stringify(response.data))
  const data = JSON.parse(res.data)
  localStorage.setItem("userId", data.userid);
  return data.userid;
}

// 获取签名
export const fetchSignatures = async () => {
  const response = await api.get<any>('/qywxapi/utils/signatures', {
    params: {
      url: window.location.href
    }
  })

  return response.data;
}
//获取agentConfig的ticket
export const getSignaturesTicket = async () => {
  const response = await api.get<TicketRes>('/qywxapi/utils/agentConfig/signatures', {
    params: {
      url: window.location.href.split('#')[0]
    }
  })
  return response.data;
}
//提交关联孩子信息
export const addparent = async (params:any) => {
  const response = await api.post<TicketRes>('/api/v1/sch/studentguardians/helpBindChild', params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//提交心仪照片
export const photos = async (params:any) => {
  const response = await api.post<TicketRes>(`/api/v1/photo/order/selectPhotoTemplate`,params,
  {
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//查询当前客服是否已绑定手机号
export const isboundServiceUser = async (userId: any) => {
  const response = await api.post<any>(`/qywxapi/utils/isboundServiceUser?userId=${userId}`)
  return response.data;
}
//绑定手机号
export const boundServiceUser = async (userId: any,mobile:any) => {
  const response = await api.post<any>(`/qywxapi/utils/boundServiceUser?serviceId=${userId}&mobile=${mobile}`,{},{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//获取选片师
export const getfilmmaker = async (activityId: any) => {
  const response = await api.post<any>(`/qywxapi/utils/getfilmmaker?activityId=${activityId}`)
  return response.data;
}
//获取套餐
export const getPackage = async (params: any) => {
  const response = await api.post<any>(`/api/v1/photo/activitystudio/get/package`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//生成订单
export const addOrder = async (params: any) => {
  console.log('params',params)
  const response = await api.post<any>(`/api/v1/photo/order/add`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//根据订单查询选择照片
export const selectAllOrderPhotos = async (params: any) => {
  console.log('params',params)
  const response = await api.post<any>(`/api/v1/photo/order/selectAllOrderPhotos`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//获取最大入册数量和最小数量
export const getMaxMinPhoto = async (params: any) => {
  console.log('params',params)
  const response = await api.post<any>(`/api/v1/photo/order/getMaxMinPhoto`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//修改为线下支付订单
export const OrderSuccess = async (params: any) => {
  console.log('params',params)
  const response = await api.post<any>(`/api/v1/photo/order/payment/success`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//添加备注
export const editByTradeSn = async (params: any) => {
  console.log('params',params)
  const response = await api.post<any>(`/api/v1/photo/order/editByTradeSn`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//删除订单
export const deleteByTradeSn = async (params: any) => {
  console.log('params',params)
  const response = await api.post<any>(`/api/v1/photo/order/deleteByTradeSnAndName`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//退款
export const refund = async (params: any) => {
  console.log('params',params)
  const response = await api.post<any>(`/api/v1/photo/order/payment/refund`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//获取年级班级
export const getschooloptionsbyactivityid = async (params: any) => {
  const response = await api.post<any>(`/api/v1/sch/class/getschooloptionsbyactivityid`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//获取已绑定孩子
export const getBindStudentList = async (params: any) => {
  const response = await api.post<any>(`/api/v1/sch/guardians/getBindStudent`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//解绑孩子
export const parentandstuunbind = async (params: any) => {
  const response = await api.post<any>(`/api/v1/sch/guardians/parentandstuunbind`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//查询活动列表
export const getdatalist = async (params: any) => {
  const response = await api.post<any>(`/qywxapi/utils/getActivityIng`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//查询学生id
// export const getStudentByClassId = async (params: any) => {
//   const response = await api.post<any>(`/api/v1/sch/student/getStudentByClassId`,params,{
//     headers: {
//       'User-CompanyId': 1
//     }
//   })
//   return response.data;
// }
//查询所有学生
export const getStudentByClassId = async (params: any) => {
  const response = await api.post<any>(`/api/v1/sch/student/getdata`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//查询选片记录
export const selectionRecordList = async (params: any) => { 
  const response = await api.post<any>(`/api/v1/photo/selection/record/getData`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//修改选片备注
export const selectionRecordEdit = async (params: any) => { 
  const response = await api.post<any>(`/api/v1/photo/select/detail/edit`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//获取所有的选片师
export const getAllSelector = async () => { 
  const response = await api.post<any>(`/api/v1/photo/users/getAllSelector`,{},{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//修改订单
export const orderEdit = async (params: any) => { 
  const response = await api.post<any>(`/api/v1/photo/order/edit`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//请求订单详情
export const getPhotoOrderDetail = async (params: any) => { 
  const response = await api.post<any>(`/api/v1/photo/order/getPhotoOrderDetail`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//照片移动
export const moveStudentPhoto = async (params: any) => { 
  const response = await api.post<any>(`/api/v1/photo/student/activity/moveStudentPhoto`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//查询群发用户
export const getGuardiansByActivityId = async (params: any) => { 
  const response = await api.post<any>(`/api/v1/photo/member/getGuardiansByActivityId`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//提交群发预约多选人员
export const sendAppointmentTime = async (params: any) => {
  const response = await api.post<any>(`/qywxapi/utils/sendAppointmentTime`,params,{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}
//获取录音地址
export const history = async (roomId: any) => {
  const response = await api.post<any>(`/api/v1/photo/nertc/cloudrecord/history/${roomId}`,{},{
    headers: {
      'User-CompanyId': 1
    }
  })
  return response.data;
}







export default api
